import React, { useState } from "react";
import {theme,Tooltip, Modal, Badge, Button, Popover, Form, Input } from 'antd';
import {
  ExclamationCircleOutlined,
  HistoryOutlined,
  FilePdfOutlined,
  PrinterOutlined,
} from '@ant-design/icons';
import ColorButton from "../../common/ColorButton";
import TSTable from "../../common/TSTable";
import { LAB_COLOR, PRIMARY_COLOR, PRINT_COLOR } from "../../constants/color";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faFlask, faStore } from "@fortawesome/free-solid-svg-icons";
import { useNavigate } from "react-router-dom";
import { PATH } from "../../routes/CustomRoutes";
import { LAB_ORDER_TYPE, TANK_ACTION, TANK_STATUS, TANK_STATUS_OPTIONS, TANK_STATUS_TH } from "../../constants/string";
import { URL_REPORT, URL_TANK } from "../../constants/urls";
import { CHEMICAL } from "../../constants/chemical";
import _ from "lodash";
import { formatComma, toFixed } from "../../frameworks/Util";
import { POST } from "../../frameworks/HttpClient";
import ErrorMessages from "../../common/ErrorMessages";
import ReportButton from "../common/ReportButton";
import TankCertificatePrintButton from "./TankCertificatePrintButton";

export default function LabStorageTankList() {
  const navigate = useNavigate();
  const columnChemicalWidth = 60;
  const tableRef = React.useRef();
  const [errorMessages , setErrorMessages] = useState(null);  

  const [form] = Form.useForm(); 

  const {
    token: { colorSuccess },
  } = theme.useToken();

  const confirm = (title, value) => {
    Modal.confirm({
      title: `เปิดแทงก์ขาย - ${title}`,
      icon: <ExclamationCircleOutlined style={{ color : PRIMARY_COLOR}} />,
      content: 'คุณต้องการเปิดแทงก์เพื่อขายใช่หรือไม่ ?',
      okText: 'ใช่',
      cancelText: 'ปิด',
      maskClosable: true,
      okButtonProps: {style: { backgroundColor : PRIMARY_COLOR}},
      onOk:async() => {
        await handleOpenTankSell(value)
        refreshData();
      },
      onConfirm: () => refreshData()
    });
  };

  const handleOpenTankSell = async(id) => {
    try {
      const data = { action : TANK_ACTION.SELL}
      await POST(`${URL_TANK.TANK_TRANSACTION}${id}/change-state/`, data)
      refreshData();
    } catch (error) {
      setErrorMessages(error.errorMessages); 
    }
  }

  const refreshData = async() => {
    if(tableRef.current)(
      await tableRef.current.fetchWithoutResetPage()
    )
  }


  const columns = [
    {
      title: 'Action',
      dataIndex: '',
      fixed: 'left',
      key: 'action',
      render: (_, original) => {
        return (
          <div 
            style={{textAlign:'center'}}
            onClick={(e) => {
              e.stopPropagation()
            }}
          >
            <Tooltip triger='hover' title={original.state !== TANK_STATUS.END ? "ส่งผลแล็บ" : "ประวัติการส่งผลแล็บ"}>
              <Badge count={original.lab_order_count}>
              <ColorButton 
                type='primary'
                override={original.state !== TANK_STATUS.END ? LAB_COLOR : PRINT_COLOR}
                icon={original.state !== TANK_STATUS.END ? <FontAwesomeIcon icon={faFlask}/> : <HistoryOutlined />}
                style={{ marginLeft : 10}}
                onClick={()=> navigate(`${PATH.POND_LAB}/${original.id}/${LAB_ORDER_TYPE.LAB_TANK}/`)} 
              />
              </Badge>
            </Tooltip>

            <TankCertificatePrintButton original={original}/>

            {original.state === TANK_STATUS.CLOSED &&
            <Tooltip triger='hover' title={"ขาย"}>
              <ColorButton 
                type='primary'
                override={colorSuccess}
                icon={<FontAwesomeIcon icon={faStore} />}
                onClick={()=> confirm(original.lot_no, original.id)}
            /></Tooltip>}
            
          </div>
      )}
    },
    {
      title: 'แทงก์',
      dataIndex: 'tank_name',
      key: 'tank_name',
      fixed: 'left',
      searcher : true,
    },
    {
      title: 'Lot No.',
      dataIndex: 'lot_no',
      key: 'lot_no',
      fixed: 'left',
      searcher : true,
      render : (value, original) => value ? 
      <>
        {value}
        <Tooltip triger='hover' title='รายละเอียดสต๊อกน้ำยางข้น'>
          <Button type='link' icon={<FilePdfOutlined />} onClick={() => window.open(`${window.origin}${PATH.TANK_SUMMARY}/${original.id}`)}/>
        </Tooltip>
      </> : '-'
    },
    {
      title: 'เกรด',
      dataIndex: 'product_name',
      key: 'product_name',
      fixed: 'left',
    },
    {
      title: 'น้ำหนัก (Kgs)',
      dataIndex: 'current_weight',
      key: 'current_weight',
      fixed: 'left',
      render : (value) => formatComma(toFixed(value, 0))
    },
    {
      title: 'สถานะ',
      dataIndex: 'state',
      key: 'state',
      fixed: 'left',
      searcher : true,
      searcherOptions: TANK_STATUS_OPTIONS,
      render : (value) => TANK_STATUS_TH[value]
    },
    ...CHEMICAL.TANK.map((data) => {
      return {
        title : <center>{data.chemical}</center> ,
        dataIndex: data.chemical,
        width: columnChemicalWidth,
        key: data.chemical,
        render : (value, original) => {
          const findData = (_.find(_.get(original, 'lab_results' , []), { 'chemical': _.get(data, 'chemical' , '')} ))
          if(findData){
            return <center>{formatComma(_.get(findData, 'amount' , '-'))}</center>
          } else return <center> - </center>
        }
      }
    })
  ]

  React.useEffect(() => {
    const interval = setInterval(() => {
      refreshData();
    }, 300000);

    return () => clearInterval(interval);
  }, []);


  return(
    <div>
      <ErrorMessages message={errorMessages}/>
      <TSTable
        ref={tableRef}
        columns={columns}
        size={'small'}
        url={URL_TANK.TANK_TRANSACTION}
        params={{ordering : "state"}}
        scroll={{
          x: 'max-content',
        }}
      />
    </div>
  )
}